// Master measurement field definitions — single source of truth.
// Ordering here is the exact sequence Payal wants displayed in every view.

export const UPPER_FIELDS = [
  { key: 'length', label: 'Length' },
  { key: 'upper_chest', label: 'Upper Chest' },
  { key: 'chest', label: 'Chest' },
  { key: 'waist', label: 'Waist' },
  { key: 'hip', label: 'Hip' },
  { key: 'shoulder', label: 'Shoulder' },
  { key: 'samna', label: 'Samna' },
  { key: 'armhole', label: 'Armhole' },
  { key: 'ghera', label: 'Ghera' },
  { key: 'neck', label: 'Neck' },
  { key: 'front', label: 'Front' },
  { key: 'back', label: 'Back' },
  { key: 'sleeves_length', label: 'Sleeves L' },
  { key: 'sleeves_moore', label: 'Sleeves M' },
  { key: 'back_cross', label: 'Back Cross' },
];

export const BOTTOM_FIELDS = [
  { key: 'length', label: 'Length' },
  { key: 'waist', label: 'Waist' },
  { key: 'hip', label: 'Hip' },
  { key: 'upper_thigh', label: 'Upper Thigh' },
  { key: 'lower_thigh', label: 'Lower Thigh' },
  { key: 'moore', label: 'Moore' },
];

export const BLOUSE_FIELDS = [
  { key: 'length', label: 'Length' },
  { key: 'chest', label: 'Chest' },
  { key: 'waist', label: 'Waist' },
  { key: 'shoulder', label: 'Shoulder' },
  { key: 'samna', label: 'Samna' },
  { key: 'armhole', label: 'Armhole' },
  { key: 'dart_point', label: 'Dart Point' },
  { key: 'neck', label: 'Neck' },
  { key: 'front', label: 'Front' },
  { key: 'back', label: 'Back' },
  { key: 'sleeves_length', label: 'Sleeves L' },
  { key: 'sleeves_moore', label: 'Sleeves M' },
];

// Flat map for label lookups (e.g. "upper_chest" -> "Chest")
export const ML = {
  ...Object.fromEntries(UPPER_FIELDS.map(f => [`upper_${f.key}`, f.label])),
  ...Object.fromEntries(BOTTOM_FIELDS.map(f => [`bottom_${f.key}`, f.label])),
  ...Object.fromEntries(BLOUSE_FIELDS.map(f => [`blouse_${f.key}`, f.label])),
};

// Build the ordered group structure for display — always shows every box.
export function buildOrderedGroups(measurements = {}) {
  const mk = (prefix, fields) =>
    fields.map(f => ({
      k: `${prefix}_${f.key}`,
      label: f.label,
      v: measurements[`${prefix}_${f.key}`] || '',
    }));
  return [
    { group: 'Upper', items: mk('upper', UPPER_FIELDS) },
    { group: 'Bottom', items: mk('bottom', BOTTOM_FIELDS) },
    { group: 'Blouse', items: mk('blouse', BLOUSE_FIELDS) },
  ];
}
